import React, {useState, useEffect} from 'react';

import Modal from 'react-bootstrap/Modal';

const ChangeBizRep = ({ bizRep, bizRepList, callback }) => {
    const [show, setShow] = useState(false);
    const [newBizRep, setNewBizRep] = useState(bizRep);

    useEffect(() => {
        setNewBizRep(bizRep);
        return () => {};
    }, [bizRep]);

    const changeHandler = (e) => {
        const {name, value } = e.target;
        setNewBizRep(value);
    };

    return (
        <>
            <button className="float-right btn btn-sm btn-outline-danger btn-rounded ml-3" onClick={() => setShow(true)}>
                수정
            </button>
            <Modal show={show} onHide={() => setShow(false)} aria-labelledby="example-custom-modal-styling-title">
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">영업 담당자 지정</Modal.Title>
                </Modal.Header>
                <Modal.Body className="">
                    <p>해당 지사를 관리하는 본사 영업 담당자를 지정하고 적용 버튼을 눌러주세요.</p>
                    <div className="pl-3">
                        <select className="form-control  input-group-append" onChange={changeHandler}>
							{bizRepList && bizRepList.map((b) => {
							    return <option value={b.name} selected={b.name == bizRep}>{b.name}</option>
							})}
						</select>
                    </div>
                </Modal.Body>
                <Modal.Footer className="p-0">
                    <button
                        className="btn btn-block btn-primary"
                        disabled={bizRepList.length === 0}
                        onClick={() => {
                            callback(newBizRep);
                            setShow(0);
                        }}
                    >
                        확인
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ChangeBizRep;